
//using abstract class instead of interface
//since I needed to check the type of

export abstract class IValueObject{
    /*
    Needed for comparing purposes
    when used in templates like
    <select>.
     */
    id:number;

    abstract getValue():string|boolean|number|Date;

    abstract getLabel():string;

    /**
     * Returns true if the given object
     * implements this interface
     * @param obj
     */
    static isImplementedBy(obj:any):boolean {
        return (obj && obj['getValue']!==undefined && obj['getLabel']!==undefined);
    }
}